/**
 * 
 * Shader generates pixels from a predefined list
 * that are 'stuck' and reversed/inverted
 *
 */

import fragment from './stuckpixels.glsl';

var StuckPixels = function (_numberOfPixels, _pixelwh) {
    

    PIXI.AbstractFilter.call(this);

    this.passes = [this];
    this.shaderLength = 10;

    var numberOfPixels = _numberOfPixels || 10;
    if( numberOfPixels > 128 ){
        console.log(' - warning number of pixels in stuck pixel shader exceeded 128.');
        numberOfPixels = 128;
    }
    var wh = _pixelwh || [0.3, 0.005];
    var arrayOfPx = this.generatePixels(numberOfPixels, wh);

    this.uniforms = {
        dimensions : {type: '4f' , value: [0.0,0.0,0.0,0.0]},
        pxwh : {type: '2f', value: wh},
        numberOfPixels : {type: '1f', value: numberOfPixels },
        pixels : {type: '4fv', value: arrayOfPx }
    };

    this.fragmentSrc = fragment;

};

StuckPixels.prototype = Object.create(PIXI.AbstractFilter.prototype);
StuckPixels.prototype.constructor = StuckPixels;


StuckPixels.prototype.generatePixels = function(num, wh) {
    var ar = [];
    for( var n = 0; n < num; n++){
        // include wh, incase we later want to have a specific wh per pixel.
        var px = [ Math.random(), Math.random(), wh[0] * Math.random(), wh[1] * Math.random()];

        if( px[0] < 0.5 ){
            px[0] = 0.0;
        }else{
            px[0] = 1.0 - wh[0];
        }

        ar.push(px[0]);
        ar.push(px[1]);
        ar.push(px[2]);
        ar.push(px[3]);
    }

    if( ar.length < this.shaderLength ){
        for( var a = ar.length; ar.length < (this.shaderLength * 4); a += 0.25){
            ar.push(0.0);
        }
    }

    return ar;
}

Object.defineProperties(StuckPixels.prototype, {
    dimensions : {
        get: function() {
            return this.uniforms.dimensions.value;
        },
        set : function(value) {
            this.dirty = true;
            this.uniforms.dimensions.value = value;
        }
    },

    pxwh : {
        get: function() {
            return this.uniforms.pxwh.value;
        },
        set: function(value) {
            this.dirty = true;
            this.uniforms.pxwh.value = value;
        }
    },

    numberOfPixels : {
        get: function() {
            return this.uniforms.numberOfPixels.value;
        },
        set: function(value) {
            this.dirty = true;
            if( value > 128 ){
                value = 128;
            }
            this.uniforms.numberOfPixels.value = value;
            // update the pixel list!!!!!
            this.uniforms.pixels.value = this.generatePixels(value, this.uniforms.pxwh.value);
        }
    }
});


module.exports = StuckPixels;


/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/stuckpixels.js
 **/